export const getHeaderDescription = (
	studyLevel: string,
	uniName: string,
	subject?: string,
) => {
	if (subject) {
		return `Discover all ${studyLevel} ${subject} courses from ${uniName}. Learn more about entry requirements, fees and funding and read reviews from real students.`;
	}
	if (studyLevel.toLowerCase() === 'postgraduate') {
		return `Level up your education and discover ${studyLevel} courses from ${uniName}. Find info on entry requirements, course content and more.`;
	}
	return `Take your next step and explore the ${studyLevel} courses from ${uniName}. Find info on entry requirements, course content and more.`;
};

export const getMetadataDescription = (
	studyLevel: string,
	uniName: string,
	subject?: string,
) => {
	const subjectText = subject ? ` ${subject}` : '';
	return `Discover all ${studyLevel}${subjectText} courses from ${uniName}. Learn more about entry requirements, fees and funding and read reviews from real students.`;
};
